export const LOCALES = {
    GERMAN: "de-DE",
    ENGLISH: "en-US",
    FRENCH: "fr-FR",
};